// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div#student-no-required-assignments {
  display: flex;
  align-content: center;
  justify-content: center;
}

div#student-no-required-assignments .message-container {
  flex-wrap: wrap;
  align-self: center;
}

div#student-no-required-assignments .message-title {
  color: white;
  font-weight: bold;
  font-size: 22px;
  align-self: center;
}

div#student-no-required-assignments .message-link {
  color: white;
  font-size: 14px;
  align-self: center;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/studentui/studentNoRequiredAssignments.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["div#student-no-required-assignments {\n  display: flex;\n  align-content: center;\n  justify-content: center;\n}\n\ndiv#student-no-required-assignments .message-container {\n  flex-wrap: wrap;\n  align-self: center;\n}\n\ndiv#student-no-required-assignments .message-title {\n  color: white;\n  font-weight: bold;\n  font-size: 22px;\n  align-self: center;\n}\n\ndiv#student-no-required-assignments .message-link {\n  color: white;\n  font-size: 14px;\n  align-self: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
